/* 
Mixin for use by all our listing components.
*/
export default {
  data() {
    return {
      rowsPerPageItems: [10, 15, 20, 50, 100],
      first: true,
      expandMultiple: false
    };
  },
  computed: {
    canSort() {
      this.checkParameter("listing", "computed");
      return this.listing.paging.totalItems < this.$store.state.system.details.sortable_list_row_limit;
    },
    noDataText() {
      this.checkParameter("listing", "computed");
      if (this.listing.loading) {
        return "Loading...";
      }
      if (this.listing.criteriaInfo && this.listing.criteriaInfo.hasCriteria) {
        return "No records match the search criteria.";
      }
      if (this.defaultNoDataText) return this.defaultNoDataText;
      {
        return "No records.";
      }
    }
  },
  methods: {
    populate() {
      if (this.checkParameter("action")) {
        const hasPayload = typeof this.getActionPayload === 'function';
        const payload = hasPayload ? this.getActionPayload() : undefined;

        if (hasPayload && payload !== undefined)
        {
          return this.$store.dispatch(this.action, payload);
        }

        this.$store.dispatch(this.action);
      }
    },
    refresh() {
      this.updatePageNumber(1);
    },
    exportToJson() {
      if (this.checkParameter("exportToJsonAction")) {
        this.$store.dispatch(this.exportToJsonAction);
      }
    },
    exportToExcel() {
      if (this.checkParameter("exportAction")) {
        const hasPayload = typeof this.getExportActionPayload === 'function';
        const payload = hasPayload ? this.getExportActionPayload() : undefined;

        if (hasPayload && payload !== undefined)
        {
          return this.$store.dispatch(this.exportAction, payload);
        }

        this.$store.dispatch(this.exportAction);
      }
    },
    clearCriteria() {
      if (this.checkParameter("clearCriteriaMutation")) {
        this.$store.commit(this.clearCriteriaMutation);
        this.refresh();
      }
    },
    updatePagination(paging) {
      // this is a hack to prevent an unnecessary refresh, because we can't
      // prevent v-data-table from firing update:pagination on initialisation
      if (this.first) {
        this.first = false;
      } else {
        if (this.checkParameter("pagingMutation")) {
          this.$store.commit(this.pagingMutation, paging);
          this.populate();
        }
      }
    },
    updatePageNumber(page) {
      if (this.checkParameter("pagingMutation")) {
        this.$store.commit(this.pagingMutation, { page: page });
        this.populate();
      }
    },
    updateRowsPerPage(rowsPerPage) {
      if (this.checkParameter("pagingMutation")) {
        this.$store.commit(this.pagingMutation, { rowsPerPage: rowsPerPage, page: 1 });
        this.populate();
      }
    },
    rowSelected(id, data) {
      this.$emit("click", id, data);
    },
    expandItem(index) {
      if (!this.expandMultiple) {
        this.listing.expanded.forEach((value, otherIndex) => {
          if (value && index != otherIndex) {
            this.$store.commit(this.expandMutation, otherIndex);
          }
        });
      }
      this.$store.commit(this.expandMutation, index);
    },
    expandAll() {
      this.expandMultiple = true;
      this.listing.expanded.forEach((value, index) => {
        if (!value) {
          this.$store.commit(this.expandMutation, index);
        }
      });
    },
    collapseAll() {
      this.listing.expanded.forEach((value, index) => {
        if (value) {
          this.$store.commit(this.expandMutation, index);
        }
      });
    },
    toggleMultiple() {
      this.expandMultiple = !this.expandMultiple;
      if (!this.expandMultiple) {
        this.collapseAll();
      }
    },
    checkParameter(parameter, source = "data()") {
      if (this[parameter]) {
        return true;
      } else {
        console.error(`Listing component ${source} is missing ${parameter}`);
        return false;
      }
    }
  }
};
